import { qs, qsa, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeScaleReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  headerItems: ".section-header",
  eventItems: ".event-item",
  revealItem:
    ".animation-fade-up-split-reveal, .animation-fade-up-reveal, .image .image__reveal-container",
};

export default node => {
  let sectionIsVisible = false;
  let observer = null;
  // Each group has a staggered animation delay so we get each groups container
  const headerItems = qs(selectors.headerItems, node);

  const headerReveals = [];
  let eventItemsReveals = [];

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    // Loop through each reveal group and initialize the reveals for each item in the header
    qsa(selectors.revealItem, headerItems).forEach(revealItem => {
      // check which type of reveal needs to be initialized
      if (contains(revealItem, "animation-fade-up-split-reveal")) {
        headerReveals.push(new FadeUpSplitReveal(revealItem));
      } else if (contains(revealItem, "animation-fade-up-reveal")) {
        headerReveals.push(new FadeUpReveal(revealItem));
      }
    });

    initEventItems();

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    sectionIsVisible = true;
    // increment a delay for each group of reveal animations
    let revealGroupDelay = window.theme.animation.delay;
    // loop through each header reveal item in the group
    headerReveals.forEach(revealItem => {
      revealItem.play(revealGroupDelay);

      if (revealItem.type === "FadeUpSplitReveal") {
        revealGroupDelay += revealItem.lineCount * window.theme.animation.delay;
      } else {
        revealGroupDelay += window.theme.animation.delay;
      }
    });

    animateEventItems();
  }

  function initEventItems() {
    eventItemsReveals = [];

    if (shouldAnimate(node)) {
      const eventItems = qsa(selectors.eventItems, node);
      eventItems.forEach(item => {
        if (contains(item, "event-item--skeleton")) {
          // animate skeletons differently than regular items
          eventItemsReveals.push([new FadeUpReveal(item)]);
        } else {
          const groupReveals = [];
          qsa(selectors.revealItem, item).forEach(revealItem => {
            // check which type of reveal needs to be initialized
            if (contains(revealItem, "animation-fade-up-split-reveal")) {
              groupReveals.push(new FadeUpSplitReveal(revealItem));
            } else if (contains(revealItem, "animation-fade-up-reveal")) {
              groupReveals.push(new FadeUpReveal(revealItem));
            } else if (contains(revealItem, "image__reveal-container")) {
              groupReveals.push(new FadeScaleReveal(revealItem));
            }
          });
          eventItemsReveals.push(groupReveals);
        }
      });

      if (sectionIsVisible) {
        animateEventItems();
      }
    }
  }

  function animateEventItems() {
    // increment a delay for each item of reveal animations
    let eventItemDelay = window.theme.animation.delay;
    // loop through each group
    eventItemsReveals.forEach((eventItem, i) => {
      eventItemDelay = window.theme.animation.delay * i;

      // loop through each reveal item in the group
      eventItem.forEach(revealItem => {
        revealItem.play(eventItemDelay);

        if (revealItem.type === "FadeUpSplitReveal") {
          eventItemDelay += revealItem.lineCount * window.theme.animation.delay;
        } else {
          eventItemDelay += window.theme.animation.delay;
        }
      });
    });
  }

  return {
    initEventItems,
    destroy() {
      observer?.destroy();
    },
  };
};
